var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShowmoreTaskWideInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.5 9c0 4.136-3.364 7.5-7.5 7.5S1.5 13.136 1.5 9 4.864 1.5 9 1.5s7.5 3.364 7.5 7.5z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.165 7.918a.56.56 0 01-.164.397L9.398 10.93a.563.563 0 01-.797 0L5.997 8.315a.562.562 0 11.797-.794L9 9.736l2.205-2.215a.562.562 0 01.961.397z",
    fill: "#BDBDBD"
  })));
}

export default SvgIconShowmoreTaskWideInactive;